export const SUBMIT_ERROR_MESSAGE = "Please double check all fields.";
